import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { enGB, fr, de } from "date-fns/locale";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    availableLanguages: {
      en: {
        lang: "en",
        flag: "GB",
        dateFormat: enGB,
      },
      fr: {
        lang: "fr",
        flag: "FR",
        dateFormat: fr,
      },
      de: {
        lang: "de",
        flag: "DE",
        dateFormat: de,
      },
    },
    // debug: true,
    fallbackLng: "en",
  });
export default i18n;
